/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
const Login = () => {
  const [stateid, setstateid] = useState("block");
  const [stateid1, setstateid1] = useState("hidden");

  return (
    <div>
      <form>
        <div
          className={`grid relative max-w-96 gap-3 w-full py-5 px-5 bg-white rounded grid-cols-1 ${stateid}`}
        >
          <h1 className="font-semibold text-2xl font-primary text-center mb-4">
            FBT MEMBER LOGIN
          </h1>

          <div className="relative">
            <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
              <i className="ri-user-3-line"></i>
            </div>
            <input
              type="text"
              id="username"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Username"
              required
            />
          </div>
          <div className="relative">
            <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
              <i className="ri-key-2-line"></i>
            </div>
            <input
              type="password"
              id="password"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Password"
              required
            />
          </div>
          <span className="text-sm flex items-center gap-1 mb-2">
            <input
              id="remeberme-checkbox"
              type="checkbox"
              value="Remeber Me"
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
            ></input>
            Remeber Me
          </span>
          <div class="hover01 column w-full flex justify-center">
            <div className="w-full flex justify-center">
              <figure className="w-full flex justify-center">
                <button
                  type="submit"
                  className="rounded-lg w-4/5 justify-center flex gap-1 text-sm font-semibold bg-primary text-white hover:bg-[#100a55e5] px-7 py-3.5"
                >
                  Log In
                </button>
              </figure>
            </div>
          </div>

          <div
            onClick={(e) => {
              setstateid("hidden");
              setstateid1("block");
            }}
            className="font-secondary secondaryhover cursor-pointer"
          >
            <p className="text-sm font-medium">Forgot Password?</p>
          </div>
          <p className="text-sm font-medium">
            Don't have an account?
            <a href="/register" className="font-secondary secondaryhover">
              Sign up now
            </a>
          </p>
        </div>
      </form>
      <div
        className={`grid relative max-w-96 gap-3 w-full py-5 px-5 bg-white rounded grid-cols-1 ${stateid1}`}
      >
        <h1 className="font-semibold text-2xl font-primary text-center mb-4">
          Forget Password Reset
        </h1>
        <div className="relative">
          <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
            <i className="ri-user-3-line"></i>
          </div>
          <input
            type="email"
            id="Email"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Email Id"
            required
          />
        </div>

        <div className="w-full flex justify-center">
          <figure className="w-full flex justify-center">
            <button
              type="submit"
              className="rounded-lg w-full justify-center flex gap-1 text-sm font-semibold bg-primary text-white hover:bg-[#100a55e5] px-7 py-3.5"
            >
              Send OTP
            </button>
          </figure>
        </div>
        <div className="relative">
          <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
            <i className="ri-key-2-line"></i>
          </div>
          <input
            type="password"
            id="resetpassword"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Password"
            required
          />
        </div>
        <div className="relative">
          <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
            <i className="ri-key-2-line"></i>
          </div>
          <input
            type="password"
            id="resetconfirmpassword"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Confirm Password"
            required
          />
        </div>

        <div class="hover01 column w-full flex justify-center">
          <div className="w-full flex justify-center">
            <figure className="w-full flex justify-center">
              <button
                type="submit"
                className="rounded-lg  justify-center flex gap-1 text-sm font-semibold bg-primary text-white hover:bg-[#100a55e5] px-7 py-3.5"
              >
                Reset Password
              </button>
            </figure>
          </div>
        </div>
        <div
          onClick={(e) => {
            setstateid("block");
            setstateid1("hidden");
          }}
          className="font-secondary font-bold text-center secondaryhover cursor-pointer"
        >
          <p className="text-sm font-medium">Back to Login</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
